import { BoxProps, Flex } from '@chakra-ui/react';
import transparentize from 'polished/lib/color/transparentize';

export type LoaderOverlayProps = BoxProps & {
  fixed?: boolean;
  transparent?: boolean;
};

export function LoaderOverlay({
  fixed,
  transparent,
  children,
  ...rest
}: LoaderOverlayProps): JSX.Element {
  return (
    <Flex
      data-testid="loader-overlay"
      role="status"
      aria-busy="true"
      w="100%"
      h="100%"
      alignItems="center"
      justifyContent="center"
      backgroundColor={
        transparent ? transparentize(0.5, '#000') : 'palette_white'
      }
      {...(fixed && {
        top: 0,
        left: 0,
        position: 'fixed',
        w: '100vw',
        h: '100vh'
      })}
      {...rest}
    >
      {children}
    </Flex>
  );
}
